import { createFeatureSelector } from '@ngrx/store';
import { RoommateState } from './roommate.state';

export const selectRoommate = createFeatureSelector<RoommateState>('roomMate');
